<template>
<div class="l-fv">
  <Preview className="l-fv__preview" :createThumbnailBy="createThumbnailBy"></Preview>
  <div class="l-fv__center">
    <CopyAndList
      copy="たった３ステップで
      こんな画像を作れます"
      :introDisc="introDisc"
      textStyle="c-text-xxl">
    </CopyAndList>
  </div>
</div>
</template>

<script>
import Preview from '@/components/modules/Preview.vue'
import CopyAndList from '@/components/modules/CopyAndList.vue'

export default {
  name: 'FirstView',
  props: {
    createThumbnailBy: String,
    introDisc: Array
  },
  components: {
    Preview,
    CopyAndList
  }
}
</script>

<style lang="scss" scoped>
.l-fv {
  padding: 50px 50/1280*100vw 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @include media-queries-sp {
    display: block;
  }

  &__center {
    width: 534/1280*100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    @include media-queries-sp {
      width: 100%;
      margin: 50px auto 0;
    }
  }
  &__preview {
    width: 600/1280*100vw;
    height: 400/1280*100vw;
    transform-style: preserve-3d;
    transform: translateZ(0px);
    perspective: 1000/1280*100vw;
    position: relative;
    @include media-queries-sp {
      margin: 0 auto;
      transform: scale(1.5);
    }
  }
}
</style>
